staedtler-cookie-banner {
  .modal-cookie {
    align-items: center;
  }

  .modal-dialog {
    min-height: auto;
    max-width: 35rem;
  }

  .modal-content {
    text-align: center;
    min-height: auto;

    h2 {
      font-weight: 700;
      font-size: $h3-font-size;

      @include media-breakpoint-up(md) {
        font-size: $h2-font-size;
      }
    }

    .btn-group {
      margin: 0 -0.5rem;
    }

    .btn {
      margin: 1rem 0.5rem;
      display: block;
      flex: 1;

      @include media-breakpoint-up(md) {
        margin: 0.5rem;
      }
    }

    @include media-breakpoint-up(md) {
      .btn-group {
        display: flex;
      }
    }

    .btn-secondary {
      opacity: 0.75;
    }

    p {
      font-size: $font-size-sm;
    }

    > :last-child {
      margin-top: 1rem;
      font-size: $font-size-xs;
    }
  }

  .form-check {
    z-index: 1;
  }

  .form-check-label {
    color: $body-color;
    text-align: left;
    font-size: $font-size-sm;
    padding: 0.5rem 0;
  }

  .form-switch .form-check-input {
    margin-top: 0.625rem;
  }

  .accordion {
    margin-bottom: 1.5rem;

    max-height: calc(100vh - 460px);
    overflow-x: auto;
    -ms-overflow-style: none;
    scrollbar-width: none;

    &::-webkit-scrollbar {
      width: 0 !important;
    }
  }

  .accordion-item {
    padding: 0;

    &.open {
      .accordion-header {
        &::before,
        &::after {
          transform: rotate(1turn);
        }
      }

      .accordion-collapse {
        max-height: initial;
      }
    }
  }

  .accordion-header {
    padding: 0 2.5rem 0 0;
    font-weight: bold;
    border: 0;
    border-bottom: 1px solid var(--secondary, $secondary);
    overflow: hidden;

    &:before,
    &:after {
      right: 0.5rem;
    }
  }

  .accordion-collapse {
    width: 100%;
    padding: 0 2.5rem 0 1.5rem;
  }

  .accordion-toggle {
    position: absolute;
    top: 0;
    right: 0;
    width: 2.5rem;
    height: 2.5rem;
    border: 0;
    padding: 0;
    margin: 0;
    background: transparent;
    appearance: none;
    z-index: 1;
    cursor: pointer;

    &:focus {
      outline: 0;
    }
  }
}
